/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import FlashOnOutlinedIcon from "@mui/icons-material/FlashOnOutlined";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import APIKeys from "../../Modals/apikeys";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const servicesData = [
    {
        name: "Aramex",
        status: "active",
        environment: "Production",
        type: "Express",
        rateLimit: "100/min",
        lastCheck: "5:10 PM",
    },
    {
        name: "DHL Express",
        status: "active",
        environment: "Production",
        type: "Express",
        rateLimit: "120/min",
        lastCheck: "5:12 PM",
    },
    {
        name: "FedEx",
        status: "pending",
        environment: "Sandbox",
        type: "Express",
        rateLimit: "60/min",
        lastCheck: "Never",
    },
    {
        name: "Fetchr",
        status: "active",
        environment: "Production",
        type: "Last mile",
        rateLimit: "60/min",
        lastCheck: "4:15 PM",
    },
];

const LogisticAPI = () => {
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            {/* ---------- Page Header ---------- */}
            <div className="main_title">
                <h1>Logistics Universal API</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Logistics Universal API
                </p>
            </div>

            <div className="stats_boxes gap_m">
                {/* ACTIVE CARRIERS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            5
                            <p>Active Carriers</p>
                            <small>of 7 total</small>
                        </h2>
                        <figure className="blue">
                            <LocalShippingOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* HEALTHY CONNECTIONS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            4
                            <p>Healthy Connections</p>
                            <small>APIs responding normally</small>
                        </h2>
                        <figure className="sucess">
                            <MonitorHeartOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* ACTIVE SERVICES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            10
                            <p>Active Services</p>
                            <small>across all carriers</small>
                        </h2>
                        <figure className="sucess">
                            <FlashOnOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* ACTIVE WEBHOOKS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            0
                            <p>Active Webhooks</p>
                            <small>receiving events</small>
                        </h2>
                        <figure className="sucess">
                            <WebhookOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>
            <Box className="custom_tabs mt_20">
                <Tabs
                    value={valueTabs}
                    onChange={handleChangeTabs}
                    variant="scrollable"
                    className="custom_tabs_links" >
                    <Tab label="Carriers" {...a11yProps(0)} />
                    <Tab label="API Logs" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <div className="cards serviceCardsContainer">

                {/* Personal Details Tab */}
                <CustomTabPanel value={valueTabs} index={0}>
                    <div className="cardsGrid">
                        {servicesData.map((service) => (
                            <div
                                key={service.name}
                                className={`card ${service.status}`}
                            >
                                <div className="cardHeader">
                                    <h3>{service.name}</h3>
                                    <span className="status">{service.status}</span>
                                </div>

                                <div className="cardBody">
                                    <div className="row">
                                        <span>Environment</span>
                                        <strong>{service.environment}</strong>
                                    </div>
                                    <div className="row">
                                        <span>Type</span>
                                        <strong>{service.type}</strong>
                                    </div>
                                    <div className="row">
                                        <span>Rate Limit</span>
                                        <strong>{service.rateLimit}</strong>
                                    </div>
                                    <div className="row">
                                        <span>Last Check</span>
                                        <strong>{service.lastCheck}</strong>
                                    </div>
                                </div>

                                <div className="cardFooter">
                                    <button className="textBtn">Test</button>
                                    <button className="textBtn" onClick={()=>setOpenModal(true)}>API Keys</button>
                                    <SwitchToggle />
                                </div>
                            </div>
                        ))}
                    </div>
                </CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={1}>

                </CustomTabPanel>
            </div>
            <APIKeys
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default LogisticAPI;
